// Clickwrap client (backend/api/agreementsApi.js). The documents are
// public; accepting them is a signed-in, server-recorded act.
import { idToken } from './orgs';

const API = (process.env.REACT_APP_UPLOAD_API || '').replace(/\/+$/, '');

async function call(path, { method = 'GET', body, auth = true } = {}) {
  if (!API) throw new Error('Backend API not configured');
  const token = auth ? await idToken() : null;
  const res = await fetch(`${API}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || `${path} failed (${res.status})`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// Active documents, in order: [{ id, kind, version, title, body }]. Default
// is the per-person set (terms + privacy); 'dpa' for the organization one.
export const fetchAgreements = (kind = '') => call(`/agreements${kind ? `?kind=${encodeURIComponent(kind)}` : ''}`, { auth: false }).then((d) => d.agreements || []);

// { userOk, missing, agreements } for the signed-in person.
export const agreementsStatus = () => call('/agreements/status');

// Records acceptance of exactly the active set (409 if the text changed).
// With orgId: the organization-level documents (DPA) on behalf of an org the
// caller owns/admins — mirrored onto the org doc as `dpa`.
export const acceptAgreements = (docIds, { orgId } = {}) => call('/agreements/accept', { method: 'POST', body: { docIds, scrolled: true, ...(orgId ? { orgId } : {}) } });

// Signup creates the account before the gate mounts, so the ids the person
// read on /login are parked here and recorded by the gate right after.
const PENDING_KEY = 'fl.clickwrapPending';
export function stashPendingAcceptance(docIds) {
  try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(docIds)); } catch { /* private mode */ }
}
export function takePendingAcceptance() {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    sessionStorage.removeItem(PENDING_KEY);
    const ids = raw ? JSON.parse(raw) : null;
    return Array.isArray(ids) && ids.length ? ids : null;
  } catch {
    return null;
  }
}
